import {ReactComponent} from "./arrow-up-line.svg";

interface Props {
    fill?: string;
    width?: string;
    height?: string;
}

const ArrowUpLineIcon: React.FC<Props> = (props) => (
    <ReactComponent {...props} />
);

export default ArrowUpLineIcon;
